import {ValueObject} from '@s-ui/domain'

import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'

export class FilterStringSearchValueObject extends ValueObject {
  #string

  constructor({string}) {
    super()
    this.#string = string
  }

  static create({string}) {
    return new FilterStringSearchValueObject({string: StringSharedValueObject.create({value: string})})
  }

  static createWithSanitize({config, string}) {
    return new FilterStringSearchValueObject({
      string: StringSharedValueObject.createWithSanitize({config, value: string})
    })
  }

  get isEmpty() {
    return !this.#string.value
  }

  get value() {
    return this.#string.value
  }

  toJSON() {
    return {string: this.#string.toJSON()}
  }
}
